import React, { useState } from "react";
import { useSelector } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
// import { Button } from "@material-ui/core";

import { selectUserDetails } from "../authentication/authenticationSlice";

import { styles } from "./Test.styles";

// import { getSensors } from "../../api/fakeApi/project";
// import FakeCollection from "../../api/fakeApi/fakeCollection";
// import { sensorsSample } from "../../api/fakeApi/data/sensorsSample";
// let testCollection = new FakeCollection('fake_test', sensorsSample);

import Chart from "react-apexcharts";

function Test({ classes }) {
  const [options, setOptions] = useState({
    chart: {
      id: "line",
      toolbar: {
        show: true
      }
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
    },
  });
  const [series, setSeries] = useState([
    {
      name: "series-1",
      data: [30, 40, 45, 50, 49, 60, 70, 91],
    },
  ]);
  const user = useSelector(selectUserDetails);
  console.log("user details: %o", user);
  return (
    <div className={classes.root}>
      <h1>Test</h1>

      <Chart options={options} series={series} type="line" width="500" />

      {/* <Button color="primary" variant="contained" onClick={() => {
        let r = getSensors("1");
        console.log(r);
      }}>TEST</Button>

<Button color="secondary" variant="contained" onClick={() => {
        let r = testCollection.get();
        console.log(r);
      }}>GET ALL</Button>

      <Button color="primary" variant="contained" onClick={() => {
        let r = testCollection.get("9dbb832c-e803-475d-bafc-72942956bf94");
        console.log(r);
      }}>GET SPECIFIC</Button>

      <Button color="primary" variant="contained" onClick={() => {
        let r = testCollection.add({
          designation: "Temperatura XPTO",
          description: "Sensor externo na caixa",
          type: "TEMPERATURE",
          model: "??",
          boxId: "2",
        });
        console.log(r);
      }}>ADD</Button>

      <Button color="primary" variant="contained" onClick={() => {
        let r = testCollection.add({
          designation: "Temperatura XPTO---",
          description: "Sensor externo na caixa----",
          type: "TEMPERATURE-----",
          model: "??",
          boxId: "2",
          id: "df069443-d09c-4991-af74-f504db273c45"
        });
        console.log(r);
      }}>UPDATE</Button>

      <Button color="primary" variant="contained" onClick={() => {
        let r = testCollection.remove("9c3f0f0a-f238-4d5b-8d78-bb2aaf61de36");
        console.log(r);
      }}>DELETE</Button> */}
    </div>
  );
}

export default withStyles(styles)(Test);
